export const EDIT_PLAN_ALERT = 'Making these changes could require rerun of past accouting periods.';
